module.exports = __webpack_public_path__ + "img/activity_list.2b313c56.png";